<template>
  <div v-resize="checkMobile" data-testid="investors-page">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
    ></loading>
    <v-card>
      <v-card-title>
        <h2 class="title">{{ $t('partners.partners') }}</h2>
        <v-spacer></v-spacer>
        <v-btn small color="success" :to="{ name: 'NewInvestor' }"
          >{{ $t('partners.add') }}</v-btn
        >
        <v-btn small class="mx-2" :to="{ name: 'InvestorsArchive' }"
          >{{ $t('custom.archive') }}</v-btn
        >
      </v-card-title>

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="investors"
          :search="search"
          :loading="isLoading"
          :loading-text="$t('custom.loading_table')"
          :sort-by="['id']"
          :sort-desc="[true]"
          :items-per-page="20"
          mobile-breakpoint="100"
          :class="!isMobile ? '' : 'is-mobile'"
          :footer-props="tableFooterProps([20, 50, 100, -1])"
        >
          <template slot="header" slot-scope="props">
            <tr id="registration-step-64">
              <th v-for="header in props.headers" :key="header.text" nowrap>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="item" slot-scope="props">
            <tr
              @dblclick="replaceToInvestor(props.item)"
              style="cursor: pointer;"
            >
              <td class="text-center" :key="props.item.id">
                <router-link :to="{ path: `/investors/${props.item.id}` }">{{
                  props.item.id
                }}</router-link>
              </td>
              <td class="text-center" nowrap>
                <router-link :to="{ path: `/investors/${props.item.id}` }">{{
                  props.item.name
                }}</router-link>
              </td>
              <td class="text-center">
                {{100 - parseInt(props.item.percent)}}
              </td>
              <td class="text-center">
                {{props.item.percent}}
              </td>
              <td class="text-center">
                {{translateMode(props.item.mode)}}
              </td>
              <td class="text-center">
                {{props.item.description}}
              </td>
              <td class="text-center">
                <v-btn
                  icon
                  color="error"
                  @click="archivateInvestor(props.item)"
                  :title="$t('custom.archive')"
                  :loading="isLoadingArchivateInvestor && loading_investor_id === props.item.id"
                  :data-testid="`archive-investor-${props.item.id}`"
                >
                  <v-icon>mdi-archive-arrow-down</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import goBackMixin from "@/mixins/goBackMixin";
export default {
  mixins: [goBackMixin],
  data() {
    return {
      investors: [],
      headers: [
        { text: this.$t('custom.id'), align: "center", value: "id" },
        { text: this.$t('bookings.name'), align: "center", value: "name" },
        { text: this.$t('investor_types.company_percent'), align: "center", sortable: false },
        { text: this.$t('investor_types.investors_percent'), align: "center", value: "percent" },
        { text: this.$t('partners.mode'), align: "center", value: "mode" },
        { text: this.$t('custom.description_2'), align: "center", value: "description" },
        { text: "", align: "center", sortable: false }
      ],
      investor: {
        name: null,
        percent: 0,
        mode: "Доходы",
        description: null
      },
      search: null,
      isMobile: false,
      isLoading: false,
      isLoadingArchivateInvestor: false,
      error: "",
      loading_investor_id: null
    }
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      if (this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin || this.$store.getters.isManager) {
        this.isLoading = true;
        this.axios
          .get("/api/v1/investors", {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          })
          .then(response => {
            this.investors = response.data;
          })
          .catch(error => {
            this.setError(error, this.$t('errors.partners_load'));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.goBack();
        this.$notify(this.$t('errors.not_permitted_title'), this.$t('errors.only_admins_2'), "error", 5000);
      }
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  computed: {
  },
  methods: {
    archivateInvestor(investor) {
      this.loading_investor_id = investor.id;
      this.isLoadingArchivateInvestor = true;
      this.axios
        .patch(`/api/v1/investors/${investor.id}`,
          {
            investors: {
              archived: true,
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken
            }
          }
        )
        .then(response => {
          this.investors = this.investors.filter(
            item => item.id !== investor.id
          );
          this.$notify(this.$t('custom.success'), this.$t('partners.archived'), "success", 3000);
        })
        .catch(error => {
          this.setError(error, this.$t('errors.partners_archive'));
          console.log(error);
        })
        .finally(() => (this.isLoadingArchivateInvestor = false));
    },
    translateMode(mode) {
      let group_text = "";
      switch (mode) {
        case "Доходы":
          group_text = this.$t("investor_types.income");
          break;
        case "Доходы - Расходы":
          group_text = this.$t("investor_types.income_expences");
          break;
        case "Доходы - (Комиссия партнера - Расходы)":
          group_text = this.$t("investor_types.income_expences_with_commission");
          break;
      }
      return group_text;
    },
    replaceToInvestor(investor) {
      this.$router.push({ path: `/investors/${investor.id}` });
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    }
  },
  components: {}
};
</script>
